import type { SystemProps } from "../../utils/types/system";
import { styled } from "../../utils/system/factory";

export type BoxProps = SystemProps<"div">;

/** @internal */
export const Box = styled.div;

Box.displayName = "Box";
